// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1wui-","dragIcon":"SortableItem_dragIcon__1kvfj","disabled":"SortableItem_disabled__2tXo5"};